export class ExhaustiveCheckError extends Error {
    constructor(public uncheckedValue: never) {
        super("Unhandled case: " + uncheckedValue);
    }
}
